export enum TAP_ORIENTATION {
  TOP_TO_BOTTOM = 'top_to_bottom',
  LEFT_TO_RIGHT = 'left_to_right'
}
